import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createContext } from 'react';
import T from 'prop-types';
import styled, { css } from 'styled-components';
import { unit } from '../../styles/unit';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_SPACING = 6;
const DEFAULT_SPACING_DIRECTIONS = ['horizontal'];
/* Context */

const GridContext = /*#__PURE__*/createContext({
  spacing: DEFAULT_SPACING,
  spacingDirections: DEFAULT_SPACING_DIRECTIONS
});
/* Column */

const HorizontalColumnSpacing = /*#__PURE__*/css(["padding-left:", ";"], props => unit(props.spacing));
const VerticalColumnSpacing = /*#__PURE__*/css(["padding-top:", ";"], props => unit(props.spacing));
const ColumnContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ColumnContainer",
  componentId: "fv4ot6-0"
})(["box-sizing:border-box;", " ", ""], props => props.spacingDirections.includes('horizontal') && HorizontalColumnSpacing, props => props.spacingDirections.includes('vertical') && VerticalColumnSpacing);
export const Column = (_ref) => {
  let {
    children,
    width = '100%'
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "width"]);

  return /*#__PURE__*/_jsx(GridContext.Consumer, {
    children: ({
      spacing,
      spacingDirections
    }) => /*#__PURE__*/_jsx(ColumnContainer, Object.assign({}, restProps, {
      spacing: spacing,
      spacingDirections: spacingDirections,
      style: {
        width
      },
      children: children
    }))
  });
};
Column.propTypes = {
  children: T.node,
  width: T.string
};
/* Grid */

const HorizontalGridSpacing = /*#__PURE__*/css(["margin-left:", ";"], props => unit(props.spacing * -1));
const VerticalGridSpacing = /*#__PURE__*/css(["margin-top:", ";"], props => unit(props.spacing * -1));
const GridContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridContainer",
  componentId: "fv4ot6-1"
})(["display:flex;flex-flow:row wrap;", " ", ""], props => props.spacingDirections.includes('horizontal') && HorizontalGridSpacing, props => props.spacingDirections.includes('vertical') && VerticalGridSpacing);
export const Grid = (_ref2) => {
  let {
    children,
    spacing = DEFAULT_SPACING,
    spacingDirections = DEFAULT_SPACING_DIRECTIONS
  } = _ref2,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["children", "spacing", "spacingDirections"]);

  return /*#__PURE__*/_jsx(GridContainer, Object.assign({
    spacing: spacing,
    spacingDirections: spacingDirections
  }, restProps, {
    children: /*#__PURE__*/_jsx(GridContext.Provider, {
      value: {
        spacing,
        spacingDirections
      },
      children: children
    })
  }));
};
Grid.propTypes = {
  children: T.node,
  spacing: T.number,
  spacingDirections: T.arrayOf(T.oneOf(['vertical', 'horizontal']))
};